//@flow

import React from "react"
import { FormattedMessage, injectIntl } from "react-intl"
import SVGLoader from "../../../UI/SVGLoader"
import TitleIcon from "../../Shared/TitleIcon"
import CTA from "../../Shared/CTA"
import { Cubic, Back, TweenMax } from "gsap"

import {
  Intro,
  IntroTitle,
  IntroDescription,
  ContentContainer,
  CloudOne,
  CloudTwo,
  CloudThree,
  Ozone
} from "./UI"

import iconDaily from "../../Icons/iconDaily.svg"

import ozoneMonster from "./ozoneMonster.svg"
import cloudOne from "./cloudOne.svg"
import cloudTwo from "./cloudTwo.svg"
import cloudThree from "./cloudThree.svg"

import type { IntlShape } from "react-intl"

type Props = {
  intl: IntlShape
}

class IntroView extends React.Component<Props> {
  introText: HTMLElement[]
  clouds: HTMLElement[]
  ozoneMonster: ?HTMLElement
  container: ?HTMLElement

  constructor(props: Props) {
    super(props)
    this.introText = []
    this.clouds = []
    this.ozoneMonster = null
    this.container = null
  }

  componentDidMount() {
    TweenMax.set(this.ozoneMonster, {
      scale: 0.9,
      transformOrigin: "50% 100%",
      opacity: 0,
      y: 200
    })
    TweenMax.set(this.clouds.filter(el => el !== null), { opacity: 0.52 })
    TweenMax.set(this.container, { opacity: 0, y: -40 })
    TweenMax.to(this.ozoneMonster, 0.35, {
      opacity: 1,
      ease: Cubic.easeOut,
      delay: 1
    })
    TweenMax.to(this.ozoneMonster, 0.75, { y: 0, ease: Back.easeOut, delay: 1 })
    TweenMax.to(this.container, 1, { ease: Cubic.easeOut, opacity: 1, y: 0 })
    this.showIntroText()
  }

  showIntroText = () => {
    const intro = this.introText.filter(el => el !== null)
    TweenMax.set(intro, { y: "40", opacity: 0 })
    TweenMax.staggerTo(
      intro,
      0.5,
      { y: "0", opacity: 1, ease: Cubic.easeOut, delay: 0.5 },
      0.2
    )
    TweenMax.staggerTo(
      this.clouds.filter(el => el !== null),
      5,
      { y: 30, ease: Back.easeInOut, repeat: -1, yoyo: true },
      1.75
    )
  }

  render() {
    const { intl: { formatMessage } } = this.props
    return (
      <ContentContainer innerRef={el => (this.container = el)}>
        <Intro>
          <TitleIcon innerRef={el => this.introText.push(el)}>
            <SVGLoader
              path={iconDaily}
              height="100%"
              width="100%"
              fill="#fff"
            />
          </TitleIcon>
          <div>
            <IntroTitle innerRef={el => this.introText.push(el)}>
              <FormattedMessage id="kiosk.commit.title" />
            </IntroTitle>
            <IntroDescription innerRef={el => this.introText.push(el)}>
              <FormattedMessage id="kiosk.commit.intro" />
            </IntroDescription>
            <CTA
              direction="down"
              message={formatMessage({ id: "kiosk.commit.cta" })}
              appearance="dark"
              innerRef={el => this.introText.push(el)}
            />
          </div>
        </Intro>
        <CloudOne innerRef={el => this.clouds.push(el)}>
          <SVGLoader path={cloudOne} height="100%" width="100%" />
        </CloudOne>
        <CloudTwo innerRef={el => this.clouds.push(el)}>
          <SVGLoader path={cloudTwo} height="100%" width="100%" />
        </CloudTwo>
        <CloudThree innerRef={el => this.clouds.push(el)}>
          <SVGLoader path={cloudThree} height="100%" width="100%" />
        </CloudThree>
        <Ozone innerRef={el => (this.ozoneMonster = el)}>
          <SVGLoader path={ozoneMonster} height="100%" width="100%" />
        </Ozone>
      </ContentContainer>
    )
  }
}

export default injectIntl(IntroView)



// WEBPACK FOOTER //
// ./src/Kiosk/CommitView/Intro/index.js